import { addDoc, collection, doc, getDoc, getDocs, updateDoc } from "@firebase/firestore";
import { hideLoading, setCurrentItem, showLoading } from "./bids-item-slice";
import { showErrorSnackbar, showSuccessSnackbar, showWarningSnackbar } from "../../../shared/snackbar/snackbar-slice";

export const getCurrentItemService1 = async (dispatch, db, coll) => {
    // dispatch(showLoading());
    try {
        await getDocs(collection(db, coll))
        .then((querySnapshot) => {
            const data = querySnapshot.docs
                .map((doc) => ({...doc.data(), id:doc.id}));
            dispatch(setCurrentItem(data));
        });
    } catch(e) {
        console.error("BidsItem getCurrentItemService error: ", e);
    }
    finally {
        // This block will always execute, even if there's an exception
        // dispatch(hideLoading()); // Make sure this is here
    }
};

export const getCurrentItemService = async (dispatch, db, coll, id) => {
    // dispatch(showLoading());
    try {
        const docRef = doc(db, coll, id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            dispatch(setCurrentItem(docSnap.data()));
            return docSnap.data();
        } else {
            dispatch(showWarningSnackbar("This document no longer exists."));
        }
    } catch(e) {
        console.error("BidsItem getCurrentItemService error: ", e);
    }
    finally {
        // This block will always execute, even if there's an exception
        // dispatch(hideLoading()); // Make sure this is here
    }
};

export const editItemService = async (dispatch, db, coll, id, formData) => {
    dispatch(showLoading());
    try {
        await updateDoc(doc(db, coll, id), formData);
        // Wait for the document to be updated
        await new Promise(resolve => setTimeout(resolve, 1000));
        const docSnap = await getDoc(doc(db, coll, id));
        const updatedData = docSnap.data();
        const data = {
            ...updatedData,
            id: id,
        };
        dispatch(showSuccessSnackbar('Bid successful!'));

        dispatch(setCurrentItem(data));
    } catch(e) {
        dispatch(showErrorSnackbar('Bid failed! Please, try again.'));
        console.error("BidsItem editItemService error: ", e);
    }
    dispatch(hideLoading());
};

export const addBidderService = async (dispatch, db, coll, formData) => {
    // dispatch(showLoading());
    try {
        await addDoc(collection(db, coll), formData);
        // dispatch(addBid({
        //     id: docRef.id,
        //     ...formData
        // }));
        // dispatch(showSuccessSnackbar('Added successfully!'));
        
    } catch(e) {
        dispatch(showErrorSnackbar('Add failed! Please try again.'));
        console.error("BidAdd addBidderService error: ", e);
    }
    // dispatch(hideLoading());
};